import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomReportsService,
  // eslint-disable-next-line camelcase
  type Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto,
} from '../../services/wealthlane-report-services';

const useGetCustomReportById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string,
  dto?: any
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto | undefined,
  unknown
> => {
  const customReportById = useQuery(
    ['customReportById', id],
    async () => {
      if (dto) {
        const dtoData = typeof dto === 'string' ? JSON.parse(dto) : dto;
        const filteredValue = {
          ...dtoData,
          requiredFieldBuckets: dtoData.requiredFieldBuckets?.map((item: any) => ({
            ...item,
            userFieldFormats: [
              {
                key: item?.userFieldFormats && item?.userFieldFormats[0]?.key,
                value: item?.userFieldFormats && '',
                placeholder: item?.userFieldFormats && item?.userFieldFormats[0]?.placeholder,
              },
            ],
          })),
          optionalFieldBuckets: dtoData.optionalFieldBuckets?.map((item: any) => ({
            ...item,
            userFieldFormats:
              (item?.userFieldFormats?.length ?? 0) > 0
                ? item?.userFieldFormats?.map((format: any, index: number) => ({
                    key: format?.key,
                    value: format?.value && '',
                    placeholder: format?.placeholder,
                  }))
                : [
                    {
                      key: item?.userFieldFormats && item?.userFieldFormats[0]?.key,
                      value: item?.userFieldFormats && '',
                      placeholder: item?.userFieldFormats && item?.userFieldFormats[0]?.placeholder,
                    },
                  ],
          })),
        };
        return filteredValue;
      }
      return await handleRequest(
        CustomReportsService.getApiReportApiAppCustomReportsCustomReportById(id)
      ).then((response) => {
        if (response != null) {
          const filteredValue = {
            ...response,
            requiredFieldBuckets: response.requiredFieldBuckets?.map((item) => ({
              ...item,
              userFieldFormats: [
                {
                  key: item?.userFieldFormats && item?.userFieldFormats[0]?.key,
                  value: item?.userFieldFormats && '',
                  placeholder: item?.userFieldFormats && item?.userFieldFormats[0]?.value,
                },
              ],
            })),
            optionalFieldBuckets: response.optionalFieldBuckets?.map((item) => ({
              ...item,
              // userFieldFormats: [
              //   {
              //     key: item?.userFieldFormats && item?.userFieldFormats[0]?.key,
              //     value: item?.userFieldFormats && '',
              //     placeholder: item?.userFieldFormats && item?.userFieldFormats[0]?.value,
              //   },
              // ],
              userFieldFormats:
                (item?.userFieldFormats?.length ?? 0) > 0
                  ? item?.userFieldFormats?.map((format, index) => ({
                      key: format?.key,
                      value: format?.value && '',
                      placeholder: format?.value,
                    }))
                  : [
                      {
                        key: item?.userFieldFormats && item?.userFieldFormats[0]?.key,
                        value: item?.userFieldFormats && '',
                        placeholder: item?.userFieldFormats && item?.userFieldFormats[0]?.value,
                      },
                    ],
            })),
          };
          return filteredValue;
        }
      });
    },
    {
      enabled: !!id,
    }
  );

  return customReportById;
};

export default useGetCustomReportById;
